import React, { useContext, useEffect } from "react";
import { ThreeRow } from "../../core/layouts";
import ViewUserBasicDetailsContainer from "../ViewUserBasicDetailsContainer";
import ViewUserRoleDetailsContainer from "../ViewUserRoleDetailsContainer";
import variables from "../../themes/base/styles/variables";
import ProductAndSubProductViewOnlyContainer from "../ProductAndSubProductViewOnlyContainer";
import ViewUserEmailsAndDnsdDetailsContainer from "../ViewUserEmailsAndDnsdDetailsContainer";
import { UserContext } from "../../globalContext/Users/userProvider";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import UserService from "../../services/user-service";
import ViewUserDetailsImageContainer from "../ViewUserDetailsImageContainer";
import { GlobalLoaderContext } from "../../globalContext/globalLoader/globalLoaderProvider";
import { getUserById } from "../../globalContext/Users/userActions";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";

const viewUserDetailsContainerStyles = {
  mainContainerStyle: {
    padding: variables.paddingMediumLarge,
    position: "relative",
    gap: variables.marginMediumLarge,
    overflow: "auto",
    height: variables.fullHeight,
  },
  bottomSectionWrapperStyle: {
    width: variables.fullWidth,
  },
};

export default function ViewUserDetailsContainer() { // NOSONAR
  const [userState, userDispatch] = useContext(UserContext);
  const [, loaderDispatch] = useContext(GlobalLoaderContext);
  const { id } = useParams();
  const intl = useIntl();

  useEffect(() => {
    if (id) {
      UserService.getUserDetailsById(userDispatch, loaderDispatch, id, intl);
    }
    return () => userDispatch(getUserById({}));
  }, [id]);

  const formatSubProductsCategoryArray = (array) => {
    return array?.map((item) => {
      return {
        ...item,
        id: item?.productCategoryId,
        subCategory: item?.subCategory?.map((subItem) => {
          return {
            ...subItem,
            name: subItem?.subCategoryName,
          };
        }),
      };
    });
  };

  const getProductsByRoleName = (userProductCategory, roleName) => {
    let subCategoryProductsArray = [];
    for (let i = 0; i < userProductCategory?.length; i++) {
      if (userProductCategory[i].roleName === roleName) {
        subCategoryProductsArray = userProductCategory[i]?.category;
        break;
      }
    }
    return formatSubProductsCategoryArray(subCategoryProductsArray);
  };

  const checkWhetherProductsSelected = (userProductCategory, roleName) => {
    for (let i = 0; i < userProductCategory?.length; i++) {
      if (
        userProductCategory[i]?.roleName === roleName &&
        userProductCategory[i]?.category?.length > 0
      ) {
        return true;
      }
    }
    return false;
  };

  const isRoleIncluded = (array, roleName) => {
    return array?.some((item) => item.name === roleName);
  };

  const isCARoleIncluded = isRoleIncluded(userState?.userData?.roles, "CA");
  const isDNSDRoleIncluded = isRoleIncluded(userState?.userData?.roles, "DNSD");
  const isTMRoleIncluded = isRoleIncluded(userState?.userData?.roles, "TM");

  const areProductsSelectedForTM = isTMRoleIncluded
    ? checkWhetherProductsSelected(
        userState?.userData?.userProductCategory,
        "TM"
      )
    : false;
  const areProductsSelectedForDNSD = isDNSDRoleIncluded
    ? checkWhetherProductsSelected(
        userState?.userData?.userProductCategory,
        "DNSD"
      )
    : false;

  return (
    <ThreeRow
      style={viewUserDetailsContainerStyles.mainContainerStyle}
      topSection={
        <ViewUserBasicDetailsContainer userData={userState?.userData} />
      }
      middleSection={
        <ViewUserRoleDetailsContainer userData={userState?.userData} />
      }
      bottomSection={
        <ThreeRow
          style={viewUserDetailsContainerStyles.cardsContainer}
          topSection={
            <div
              style={viewUserDetailsContainerStyles.bottomSectionWrapperStyle}
            >
              {isCARoleIncluded && (
                <ProductAndSubProductViewOnlyContainer
                  productSubProductsOptions={getProductsByRoleName(
                    userState?.userData?.userProductCategory,
                    "CA"
                  )}
                  roleName={"Country Admin"}
                />
              )}

              {isTMRoleIncluded && areProductsSelectedForTM && (
                <ProductAndSubProductViewOnlyContainer
                  productSubProductsOptions={getProductsByRoleName(
                    userState?.userData?.userProductCategory,
                    "TM"
                  )}
                  roleName={"Team Member"}
                  style={{ marginTop: variables.marginMediumLarge }}
                />
              )}

              {isDNSDRoleIncluded && areProductsSelectedForDNSD && (
                <ProductAndSubProductViewOnlyContainer
                  productSubProductsOptions={getProductsByRoleName(
                    userState?.userData?.userProductCategory,
                    "DNSD"
                  )}
                  roleName={getLocalizedMessage(
                    intl,
                    "userManagement.roleName.densoService"
                  )}
                  style={{ marginTop: variables.marginMediumLarge }}
                />
              )}
            </div>
          }
          middleSection={
            isTMRoleIncluded &&
            userState?.userData?.imageId !== null && (
              <ViewUserDetailsImageContainer userData={userState?.userData} />
            )
          }
          bottomSection={
            isDNSDRoleIncluded && (
              <ViewUserEmailsAndDnsdDetailsContainer
                otherEmail={userState?.userData?.otherEmail}
                address={userState?.userData?.address}
              />
            )
          }
        />
      }
    />
  );
}
